/*
This script is used for the preview views, which have a tab panel to select Japanese or English.
When the view loads, no tab is selected by default (the class "active" has to be added in the tab panels
and contents), so this script selects the first tab by default if no tab is selected.
*/
function selectFirstTab(){

  const tabPanelRole = "preview-language-tab-panel";

  const $panels = $(`[data-role=${tabPanelRole}]`);

  if($panels.length === 0){
    // This view doesn't contain any language tab panel.
    return;
  }

  $panels.each((i, ele) => {
    const $panel = $(ele);
    if($panel.find('[data-toggle="tab"].active').length === 0){
      // It doesn't have an active tab, so select first by default.
      $panel.find('[data-toggle="tab"]').first().trigger("click");
    }
  });

  
};

export { selectFirstTab };
